import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import PropTypes from 'prop-types';
import { format as formatDate } from '@wordpress/date';
/**
 * Use the `Date` component to display accessible dates or times.
 *
 * @return { object } -
 */

var Date = function Date(_ref) {
  var date = _ref.date,
      machineFormat = _ref.machineFormat,
      screenReaderFormat = _ref.screenReaderFormat,
      visibleFormat = _ref.visibleFormat;
  return createElement("time", {
    dateTime: formatDate(machineFormat, date)
  }, createElement("span", {
    "aria-hidden": "true"
  }, formatDate(visibleFormat, date)), createElement("span", {
    className: "screen-reader-text"
  }, formatDate(screenReaderFormat, date)));
};

Date.propTypes = {
  /**
   * Date to use in the component.
   */
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,

  /**
   * Date format used in the `datetime` prop of the `time` element.
   */
  machineFormat: PropTypes.string,

  /**
   * Date format used for screen readers.
   */
  screenReaderFormat: PropTypes.string,

  /**
   * Date format displayed in the page.
   */
  visibleFormat: PropTypes.string
};
Date.defaultProps = {
  machineFormat: 'Y-m-d H:i:s',
  screenReaderFormat: 'F j, Y',
  visibleFormat: 'Y-m-d'
};
export default Date;
//# sourceMappingURL=index.js.map